/*	MARK: Samantia Machine Bulk Prediction
	============================================
 */
/** Imports **/
import { inject, PLATFORM } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request, AuthRequest } from '../services/data-service';
import { Api } from '../services/api';
import { MachineStatus, MachineSignal, FormatBytes } from './machine-schemas';
import { ZSC, Sammy } from './palette';
import Plotly from 'plotly.js-dist-min';
const ObjectID = require('bson-objectid');

// Events
import { EventAggregator } from 'aurelia-event-aggregator';
import { NotificationEvent } from './notification'

const Stages = {
	Upload:"Upload", Ready:"Ready",
	InProcess:"InProcess", Done:"Done"
}

@inject(DataService, Api, Router, EventAggregator)
export class MachineBulkPredictin {
	/** Components methods **/
	constructor(ds, api, router, ea){
		// Services
		this.ds		= ds;
		this.api	= api;
		this.router = router;
		this.ea		= ea;
		// Section stages
		this.Stages	= Stages;
		this.stage 	= Stages.Upload
		// Target dataset
		this.sample_dataset = "";
		this.summary_data;
	}

	activate(params){ this.id = params.id; this.pid = params.pid } // MachineID

	attached(){
		/*	============================================
		  	1 Get machine from dataservice
			2 Get dataset from machine.dataset(split name)
			3 Setup machine and dataset to DataService
			============================================
		*/
		this.init();
		this.predictionDownloadSubs = this.ea.subscribe(NotificationEvent.PredictionDownload, msg => this.onPredictionDownload(msg));
	}

	detached(){ this.predictionDownloadSubs.dispose();}
	
	init(){
		/*	============================================
		  	1 Get machine from dataservice
			2 If machine existis, procede to get dataset
			  else -> get remote machine and dataset
			3 Setup machine and dataset to DataService
			============================================
		*/
		let machine = this.ds.app_data.machine;

		if(!machine){
			// Get remote machine data
			this.getMachine(this.id).then(response => {
				this.handleMachineResponse(response);
				// Get dataset?

				// Load Archive
				if(this.pid){ this.loadArchive(this.pid);}
			});
		}
		else{
			this.machine = machine;
			this.ds.app_data.machine = machine;

			// Load Archive
			if(this.pid){ this.loadArchive(this.pid);}
		}
	}


	// Load Archive
	loadArchive(pid){
		// Change Stage status (in process)
		this.stage = Stages.InProcess;

		// Load remote data
		this.getPrediction(pid).then(response => {
			this.handleGetPrediction(response);
		});
	}

	getPrediction(pid){
		let id			= this.machine._id;
		let request 	= new Request("/api/v2/machines/"+id+"/predictions/"+pid, "GET");
		return this.api.get(request);
	}

	handleGetPrediction(response){
		if(response.status === 200){
			let data	= response.data;
			this.predictionToDataService(data);
			this.stage	= Stages.Done;
			window.setTimeout( () => { this.plotPrediction(this.machine, data);}, 1);
		}
	}

	/** API Calls
		============================================
	**/

	getMachine(id){
		// Request
		let request 	= new Request("/api/v2/machines/id?", "GET");
		let params  	= new URLSearchParams({ id:id });
		request.url 	= request.url + params;
		// Perform remote call
		return this.api.get(request);
	}

	handleMachineResponse(response){
		let status = response.status;
		if(status === 200){
			let machine  = response.data;
			machine.features = machine.features
			this.machine = machine
			this.ds.app_data.machine = machine;
		};
	}

	requestQuota(machine){
		
		// Auth Request
		let subsToken		= this.ds.user.subs;
		let uid				= machine.uid;
		let request			= new AuthRequest("/api/v2/users/"+uid+"/usage-token", "POST");
		let machine_quota 	= { quota: machine.quota } // prediction
		// Add body
		let body			= { machine_quota:machine_quota, uid:machine.uid };
		request.body		= JSON.stringify(body);
		// Add subs header
		request.headers["Authorization"] = "Bearer " + subsToken; // Bearer + token
		return this.api.post(request);
	}

	/**	File upload
		============================================
	**/

	uploadFile(){

		// Change state
		this.stage = Stages.InProcess;
		
		let dataset_document = {
			name		: this.file.name, size: this.file.size,
			uid			: this.ds.user.uid, type:"source",
			is_active	:false,
		};

		let request	= new Request("/api/v2/datasets/", "POST");
		this.readFile(this.file).then(f => {
			if(f){
				let file		= f;
				let body		= { "dataset": dataset_document, "file":file };
				request.body 	= JSON.stringify(body);
				return this.api.post(request);
			}
			else{
				return new Promise(resolve => { resolve(400)});
			}
		})
		.then(response => {
			let id 		= response.data._id
			let req 	= new Request( "/api/v2/summary/","POST");
			let body 	= { dataset:response.data };
			req.body 	= JSON.stringify(body)
			this.sample_dataset = response.data.file_name
			// POST summary
			return this.api.post(req);
		})
		.then(res => {
			if(res.status === 200){
				let jsonData 		= JSON.parse(res.data);
				this.summary_data 	= jsonData;
				// samples => summary_data.data.samples
			}
			
			// Update machine
			this.stage = Stages.Ready;
		});
	}

	readFile(file){

		if(file){
			let fr = new FileReader();
			// Read as URL
			// Add event listener
			fr.addEventListener('loadstart', this.frChangeStatus('Start loading'));
			fr.addEventListener('load', this.frChangeStatus('Loaded'));
			fr.addEventListener('loadend', this.frLoaded);
			fr.addEventListener('progress', this.frSetProgress);
			fr.addEventListener('error', this.frErrorHandler);
			fr.addEventListener('abort', this.frChangeStatus('Interrupted'));

			return new Promise(resolve => {
				fr.readAsDataURL(file);
				fr.onload = () => { resolve(fr.result);};
			});
		}
		else{
			return new Promise(resolve => { resolve(null);});
		}
	}

	onSelectFile($event){
		this.file = $event.target.files[0];
		this.uploadFile();
	}
	frChangeStatus(status){
		//console.log("status: ", status);
	}
	frLoaded(e){ let file = e.target;this.fileStream = file.result;}
	frSetProgress(e){}
	frErrorHandler(e){}

	/** Actions
		============================================
	**/

	_predict(){
		// Change state
		this.stage = Stages.InProcess;		
		this.postBulkPrediction().then(response => {
			this.handlePostBulkPrediction(response);
		});
	}

	predict(){
		// Change state
		this.state = Stages.InProcess;
		// Request Operation Token
		let machine_quota 	= { ... this.machine };
		machine_quota.quota	= this.summary_data.data.samples; // Number of 
		this.requestQuota(machine_quota).then(responseQuota => {
			let status = responseQuota.status;
			if(status === 200){
				this.accessToken = responseQuota.data.oper_token;
				return this.postBulkPrediction();
			}
		})
		.then(response => {
			this.handlePostBulkPrediction(response);
		})
		.catch( (e) => { console.log("some err ocurr", e);});
	}

	// Bulk prediction
	postBulkPrediction(){
		let sample 			= this.sample_dataset // Change when ready
		//let sample			= "67ec433e3d1922cd9aa1a41a-wine_test.csv" // Test dataset
		let id 				= this.machine._id;
		let request 		= new Request("/api/v2/machines/" + id + "/predict/", "POST");
		// Copy machine
		let req_machine 		= { ... this.machine };
		req_machine.dataset 	= sample;
		// req_machine.algorithm 	= "bulk_prediction";
		let body 				= { oper:"bulk_prediction", signal:MachineSignal.Predict, machine:req_machine};
		request.body			= JSON.stringify(body);

		// Add Auth token
		request.headers["Authorization"] = "Bearer " + this.accessToken;
		
		return this.api.post(request);
	
	}
	
	handlePostBulkPrediction(response){
		let status = response.status;
		if(status === 200){
			let json_response = JSON.parse(response.data);

			if(json_response.code === 200){
				let data 		  = json_response.data;

				
				// To datservice
				data._id	= (this.pid) ? this.pid : ObjectID(Date.now()).toHexString();

				data.credentials			= {
					uid		:this.machine.uid,
					muid	:this.machine._id,
					type	:"Bulk"
				}
				this.ds.app_data.prediction = data;
				
				
				// Update state
				this.stage 		 = Stages.Done;
				window.setTimeout( () => { this.plotPrediction(this.machine, data);}, 1);
			}
			else{
				let message 			= json_response.message;
				this.stage				= Stages.Upload;
				this.showNotification(message);
			}
			
		}
	}

	predictionToDataService(data){
		// To datservice
		let pred = {... data };
		pred._id	= (this.pid) ? this.pid : ObjectID(Date.now()).toHexString();
		pred.credentials			= {
			uid		:this.machine.uid,
			muid	:this.machine._id,
			type	:"Bulk"
		}
		this.ds.app_data.prediction = pred;
	}

	showNotification(message){
		this.show_notification = true;
		this.response_message = message;
		window.setTimeout( () => { this.show_notification = false;}, 10000);
		
	}

	/** MARK: Plot methods
		============================================
	**/

	display_summary_data(res_data){
		let features 	= this.machine.features;
		let output		= this.machine.y_label;
		//features.unshift(output);
		this.summary_data = {
			headers : features,
			output	: output,
			records	: [
				{ max:res_data.max, max_datapoint:res_data.max_datapoint },
				{ max:res_data.min, max_datapoint:res_data.min_datapoint },
			],
			
		}
	}

	display_tabular_data(res_data){
		// let records = res_data.sample;
		let records	= res_data.sample.map( (x) => x);
		records.unshift(res_data.prediction)
		let tabular_data = {
			headers	: this.machine.features,
			output 	: this.machine.y_label,
			records : records,
		}
		this.tabular_data = tabular_data;
	}
	
	plotPrediction(machine, res_data){
		let X	 	= [];
		for(let i=0;i < res_data.prediction.length; i++){X.push(i);}
		//let data 	= { x:X, y: res_data.prediction };

		let trace 	= {
			x	:X,
			y	:res_data.prediction,
			mode:"markers",
			name:machine.y_label,
			marker:{ color:Sammy.Lisa , size:6, opacity:0.5 }
			// ZSC.Orange
		}

		let layout = {
			title		: machine.name + " predictions",
			showlegend 	: true,
			yaxis		:{ title: {text:machine.y_label} }
		}
		let plot_data = [ trace ];
		Plotly.newPlot(
			this.board, plot_data, layout,
			{displaylogo:false, responsive:true, scrollZoom:true}
		);
		// Display tabular data
		this.display_summary_data(res_data);
		this.display_tabular_data(res_data);
	}

	/** MARK: Events
		=================================
	**/
		toImage(){
		let image_options = { format:'png',file_name:'output', height:800, width:1024,scale:1};
		Plotly.downloadImage(this.board, image_options);
	}

	onPredictionDownload(msg){
		this.toImage();
	}
		
}
